import { agent } from '@shared/services/agent';
import { ReportConfig, ReportType, ScheduledAbsenceReport } from '@shared/models/report.models';

export async function getReportConfigs(): Promise<ReportConfig[]> {
    return await agent.requests.get('/api/report-configs');
}

export async function updateReportConfig(config: ReportConfig): Promise<void> {
    return await agent.requests.post('/api/report-config', config);
}

export async function sendSampleReport(reportType: ReportType): Promise<void> {
    return await agent.requests.post('/api/report-sample', { reportType });
}

export async function getAbsenceReports(): Promise<ScheduledAbsenceReport[]> {
    return await agent.requests.get('/api/absence-reports');
}

export async function createAbsenceReport(report: ScheduledAbsenceReport): Promise<ScheduledAbsenceReport> {
    return await agent.requests.post('/api/absence-reports', report);
}

export async function updateAbsenceReport(report: ScheduledAbsenceReport): Promise<ScheduledAbsenceReport> {
    return await agent.requests.put(`/api/absence-reports/${report.id}`, report);
}

export async function deleteAbsenceReport(id: number): Promise<void> {
    return await agent.requests.del(`/api/absence-reports/${id}`, true);
}

export async function sendAbsenceReportSample(id: number): Promise<void> {
    return await agent.requests.post(`/api/absence-reports/${id}/sample`);
}
